import React from 'react';

import { Tooltip, TooltipPosition } from 'react-magma-dom';
import { ModalButton } from '../Button';
import { COLORS } from '../../constants';
import proforma from '../../assets/proforma/proforma.jpg';
import exemplar from '../../assets/proforma/exemplar.jpg';
import { Modal } from './Modal';
import {
  StyledSaveProformaType,
  StyledSaveProformaTypesWrapper,
  StyledSaveImageWrapper,
  StyledSavePopupImage,
  StyledRelative,
} from '../Styled';

interface ISaveAsModal {
  color: string;
  onCloseClick: () => void;
  onSaveProformaClick: () => void;
  onSaveExemplarClick: () => void;
  isDisabled: boolean;
}

export const SaveAsModal: React.FC<ISaveAsModal> = (props): JSX.Element => {
  const { color, onCloseClick, onSaveProformaClick, onSaveExemplarClick, isDisabled } = props;

  const exemplarBtn = (
    <StyledRelative>
      <ModalButton
        isDisabled={isDisabled}
        bGColor={color}
        color={COLORS.white}
        text="Exemplar"
        onButtonClick={onSaveExemplarClick}
      />
    </StyledRelative>
  );

  const tooltipStyle = {
    width: '130px',
    textAlign: 'center' as CanvasTextAlign,
    fontSize: '10px',
    fontWeight: 500,
    fontFamily: 'Lexend',
    lineHeight: 'normal',
    background: '#FFFFFF',
    color: '#000000',
  };

  return (
    <Modal onCloseClick={onCloseClick} headerText={'Save as'} paddingBottom={'0px'}>
      <StyledSaveProformaTypesWrapper>
        <StyledSaveProformaType>
          <StyledSaveImageWrapper>
            <StyledSavePopupImage data-testid="save-as-image" src={proforma as string} alt="proforma" />
          </StyledSaveImageWrapper>
          <ModalButton
            bGColor={COLORS.gray95}
            borderColor={color}
            color={color}
            text="Interactive Writing Proforma"
            onButtonClick={onSaveProformaClick}
          />
        </StyledSaveProformaType>
        <StyledSaveProformaType>
          <StyledSaveImageWrapper>
            <StyledSavePopupImage data-testid="save-as-image" src={exemplar as string} alt="exemplar" />
          </StyledSaveImageWrapper>
          {isDisabled ? (
            <>
              <Tooltip
                isInverse
                content={'Please complete each section to save.'}
                position={TooltipPosition.top}
                tooltipStyle={tooltipStyle}
              >
                {exemplarBtn}
              </Tooltip>
            </>
          ) : (
            <>{exemplarBtn}</>
          )}
        </StyledSaveProformaType>
      </StyledSaveProformaTypesWrapper>
    </Modal>
  );
};
